export default __webpack_public_path__ + "static/media/BelicosoClosed.68c164ec.jpg";